export default function Style(){
  return (
    <style>
      {`
       .lh-45 {
    line-height: 45px !important;
}
.fs-36{
    font-size: 36px;
}
@media (max-width: 1534px) {
  .fs-36 {
    font-size: 32px !important;
  }
 }
 @media (max-width: 768px) {
  .fs-36 {
    font-size: 28px !important;
  }
}

@media (max-width: 992px) {
  .fs-36 {
    font-size: 30px !important;
  }
}
@media screen and (max-width :500px){
  .px-mobile-nabourhood{
    padding-left:13%;
    padding-right: 13%;
  }
 
  }
  







@media (min-width: 1543px) {
 .fs-36 {
   font-size: 36px !important;
 }
}


        `}
    </style>
  );
}
